import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { useSelector } from 'react-redux';
import { KTSVG } from 'src/_metronic/helpers';
import { RootState } from 'src/services';
import { useAppDispatch } from 'src/services/redux/app/Store';
import { setDraftTemplateReducer } from 'src/services/redux/slices/template/template-slice';
import { useCreateBanner } from '../../services';
import ImageUpload from '../ImageUpload';

type ImageUploadModalType = {
  show: boolean;
  handleClose: () => void;
  maxSize?: number;
  allowTypes?: string;
  sortIndex?: number;
  itemTypeId: number;
  templateId: number;
  maxWidth?: number;
  setBannerResponse: (data: []) => void;
};
export default function ImageUploadModal(props: ImageUploadModalType) {
  const { show, handleClose, maxSize, allowTypes, sortIndex, itemTypeId, templateId, setBannerResponse, maxWidth } = props;
  const dispatch = useAppDispatch();
  const [uploadImage, setUploadImage] = useState('');
  const [link, setLink] = useState('');
  const [title, setTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const merhcantTemplateId = useSelector<RootState, number>((state) => state.template.merchantTemplateId);
  const dismissLocation = () => {
    handleClose();
  };

  const { mutateAsync: createBanner } = useCreateBanner();

  const handleUpload = async () => {
    const activeBanner = merhcantTemplateId > 0 ? String(merhcantTemplateId) : '';
    const payload = {
      image: uploadImage,
      slug: link,
      sort: sortIndex,
      title: title,
      template: templateId,
      templateItem: itemTypeId,
    };
    const response: any = await createBanner({ payload, schema: activeBanner });
    setBannerResponse(response.bannerData.banners);
    setLink('');
    setTitle('');
    setUploadImage('');
    dispatch(setDraftTemplateReducer(true));
    handleClose();
  };

  if (!show) return null;

  const disabledRules = () => {
    if (uploadImage && link.trim() && !errorMessage) {
      return false;
    }
    return true;
  };

  const handleChangeControl = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    setLink(value);

    const trimmedValue = value.trim();

    const allowedCharsRegex = /^[a-zA-Z0-9\-_/?:=&#%]+$/;
    const turkishCharsRegex = /[çğıöşüÇĞİÖŞÜ]/;

    const onlyNumbersRegex = /^[0-9]+$/;
    const hasLetterOrNumberRegex = /[a-zA-Z0-9]/;

    if (!trimmedValue) {
      setErrorMessage('Alan boş olamaz.');
      return;
    }

    if (value !== trimmedValue || /\s/.test(value)) {
      setErrorMessage('Boşluk kullanılamaz.');
      return;
    }

    if (value.length < 2) {
      setErrorMessage('Minimum 2 karakter giriniz.');
      return;
    }

    if (value.length > 200) {
      setErrorMessage('Maximum 200 karakter giriniz.');
      return;
    }

    if (turkishCharsRegex.test(value)) {
      setErrorMessage('Türkçe karakter kullanılamaz.');
      return;
    }

    if (onlyNumbersRegex.test(value)) {
      setErrorMessage('URL sadece rakamlardan oluşamaz.');
      return;
    }

    if (!hasLetterOrNumberRegex.test(value)) {
      setErrorMessage('URL sadece slash veya özel karakterlerden oluşamaz.');
      return;
    }

    setErrorMessage('');
  };

  return (
    <Modal className="modal fade modal-lg" id="kt_modal_image_upload" data-backdrop="static" tabIndex={-1} role="dialog" show={show} aria-hidden="true" onHide={dismissLocation}>
      <div className="modal-content">
        <div className="modal-header ">
          <h5 className="modal-title">Görsel Yükle</h5>

          <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" onClick={dismissLocation}>
            <KTSVG path="/media/icons/duotone/Navigation/Close.svg" className="svg-icon-2x" />
          </div>
        </div>

        <div className="modal-body">
          <ImageUpload maxSize={maxSize ?? 0} allowTypes={allowTypes ?? ''} itemTypeId={itemTypeId} uploadedImage={setUploadImage} maxWidth={maxWidth ?? 0} />
          <div className="d-flex flex-column gap-4 mt-4">
            <div className="d-flex flex-column gap-2 px-2 ">
              <span className="fw-bold fs-7 text-muted">
                Bağlantı Adresi <span className="text-danger">*</span> <span className="fs-9 text-danger">( Bağlantı adresiniz idefix linki olmalıdır. )</span> :
              </span>
              <div className="d-flex align-items-center">
                <input
                  onChange={(e) => handleChangeControl(e)}
                  type="text"
                  className={`form-control form-control-sm ${errorMessage ? 'border-danger' : ''}`}
                  placeholder="https://www.siteadresi.com"
                />
              </div>
              <span className="text-danger fs-7">{errorMessage}</span>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-sm btn-secondary" onClick={dismissLocation}>
            Kapat
          </button>
          <button disabled={disabledRules()} className={`btn btn-sm btn-success`} onClick={handleUpload}>
            Yükle
          </button>
        </div>
      </div>
    </Modal>
  );
}
